<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="false">
      <CenterSearchForm
        :has_nav_bar="false"
        :width_class="page_info.center_width_class"
        :show_pagination="false"
        :disabled="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></CenterSearchForm>
      <div class="marg-top-90 bgt-1x">
        <div  v-for="num in 56" :key="num">
          slime {{num}} <br/>
        </div>
      </div>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterSearchForm from "./../../components/CenterSearchForm";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";
// import Utils from "./../../lib/Utils";
// import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Home",
  components: {
    Page,
    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,
    CenterPageColumn,
    CenterSearchForm,
    Footer,
    SelfPromoAdd,
    HomeSideAdsContainer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "home",
    quick_links: [
      {
        text: "Message Form",
        href: "#contact_form_top",
      },
      {
        text: "Contacts List",
        href: "#contact_contacts_list",
      },
      {
        text: "Social Media",
        href: "#contact_social_media",
      },
      {
        text: "Map Location",
        href: "#contact_map",
      },
    ],
    page_info: page_info,
  }),
};
</script>